module.exports = __webpack_public_path__ + "resources/img/img-zenius-ems-02.83820281a57ac3c60746e44cdba78926.png";